import React__default from 'react';
import { u as useController } from '../../3rdPartyModules/react-hook-form/dist/index.esm-CTOtYSSt.js';
import { u as useFormContext } from './hooks/useFormContext-DAFplQw7.js';

const Field = ({
  name,
  defaultValue,
  validateOnMount = true,
  children,
  id,
  rules
}) => {
  const {
    control,
    trigger
  } = useFormContext();
  // https://react-hook-form.com/api/usecontroller
  const {
    field,
    fieldState,
    formState
  } = useController({
    name,
    control,
    defaultValue,
    rules
  });
  const {
    isSubmitting
  } = formState;
  const {
    error
  } = fieldState;
  const {
    onChange: internalOnChange,
    value,
    onBlur
  } = field;
  const onChange = changeValue => {
    internalOnChange(changeValue);
    onBlur();
    // https://react-hook-form.com/docs/useform/trigger
    // user may have dependant validation
    trigger();
  };
  React__default.useEffect(() => {
    // to trigger validation on mount
    if (validateOnMount) {
      trigger([name]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children({
    field,
    fieldState,
    id,
    isSubmitting,
    error,
    value,
    onChange
  }));
};

export { Field as F };
//# sourceMappingURL=Field--hQUCvLp.js.map
